
/**
 * --- External Imports ---
 */
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

/**
 * --- Internal Imports ---
 */
import { GetParticipants, GetParticipantsResponse } from "@/apis/dtos";
import useGet from "../apis/useGet";

/**
 * --- Hook ---
 */
const getData = (response?: SWRResponse<GetParticipantsResponse, GetParticipantsResponse>) => response?.data?.participants;
const getError = (response?: SWRResponse<GetParticipantsResponse, GetParticipantsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetParticipantsResponse, GetParticipantsResponse>) => ({});

const useGetParticipants = (query?: Partial<GetParticipants>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetParticipants(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetParticipants;